module.exports = __webpack_public_path__ + "static/img/kjy.89450ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/kjy.jpg
// module id = CYF2
// module chunks = 0